module.exports = __webpack_public_path__ + "assets/images/551a5f29b184ea76e49ed06a7060b59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/ihs-logo.png
// module id = 825
// module chunks = 0